import styled from 'styled-components';

const ModalContentStyled = styled.div`
  padding: 0 24px 0 24px;
`;
export default ModalContentStyled;
